import makeUseCellCopyAction, {
  UseCellCopyActionProps,
} from "ds/components/Table/helpers/makeUseCellCopyAction";

import useStackListAnalytics from "../useStackListAnalytics";

const useCellCopyAction = (props: UseCellCopyActionProps) => {
  return makeUseCellCopyAction({ trackAnalytics: useStackListAnalytics() })(props);
};

export default useCellCopyAction;
